/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_3_HighlightInputs */

const da_forside_quote_3_highlight = /** @type {(inputs: Forside_Quote_3_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback dagen efter`)
};

/** @type {(inputs: Forside_Quote_3_HighlightInputs) => LocalizedString} */
const en_forside_quote_3_highlight = da_forside_quote_3_highlight;

/**

* @param {Forside_Quote_3_HighlightInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_3_highlight = /** @type {((inputs?: Forside_Quote_3_HighlightInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_3_HighlightInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_3_highlight(inputs)
	return /** @type {LocalizedString} */ ("Feedback dagen efter")
});